import { Box, Typography, Button } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  // boxShadow: theme.shadows[1], // Optional: Add shadow
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const ModalSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.95rem',
}));

export const WarningAlertBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFF8E1', // Light yellow background
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'flex-start', // Align to top in case text wraps
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(3),
  color: '#F57C00', // Darker Orange/Yellow for text
  border: '1px solid #FFE0B2', // Optional subtle border
}));

export const AlertText = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  fontWeight: 500,
  lineHeight: 1.5,
  color: '#D89614', // Specific dark yellow/gold color
}));

export const ButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

export const KeepShiftButton = styled(Button)(({ theme }) => ({
  flex: 1,
  borderColor: theme.palette.success.main, // Or your specific green color
  color: theme.palette.success.main,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: theme.spacing(1.2),
  borderRadius: '8px',
  '&:hover': {
    borderColor: theme.palette.success.dark,
    backgroundColor: alpha(theme.palette.success.main, 0.04),
  },
}));

export const ConfirmCancelButton = styled(Button)(({ theme }) => ({
  flex: 1,
  backgroundColor: '#FFEBEE', // Light Red bg
  color: '#D32F2F', // Red text
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: theme.spacing(1.2),
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#FFCDD2',
    boxShadow: 'none',
  },
}));